import { render, staticRenderFns } from "./_pre-orders.componentV2.vue?vue&type=template&id=bdeed81c&scoped=true"
import script from "./_pre-orders.componentV2.vue?vue&type=script&lang=js"
export * from "./_pre-orders.componentV2.vue?vue&type=script&lang=js"
import style0 from "./_pre-orders.componentV2.vue?vue&type=style&index=0&id=bdeed81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeed81c",
  null
  
)

export default component.exports